// myuae startup - front end

const isLive = process.env.REACT_APP_IS_LIVE || "YES";

const fixer_base_url = isLive === "YES" ? "https://data.fixer.io" : "http://data.fixer.io";

export const cookie_env = isLive === "YES" ? "prod" : "dev";
export const url = isLive === "YES" ? "https://myuaestartup.com/api/v1" : "http://localhost:4000/v1";
export const fixerUrl = fixer_base_url + "/api/latest?access_key=05b195861f12462b6aa6bc277e07df24&symbols=EUR,INR,AED,USD";


export const live = isLive === "NO" ? false : true;